export default [
  {
    path: "/tipos-concedentes",
    component: () => import("@/layout/Default"),
    children: [
      {
        name: "tipos_concedentes_list",
        path: "",
        component: () => import("./pages/List"),
        meta: {
          breadcrumbs: [
            { label: "Tipos_concedentes", to: "tipos_concedentes_list" }
          ],
          permission: "tipo_concedente:view",
          title: "Tipos_concedentes"
        }
      },
      {
        name: "tipos_concedentes_create",
        path: "novo",
        component: () => import("./pages/Create"),
        meta: {
          breadcrumbs: [
            { label: "Tipos_concedentes", to: "tipos_concedentes_list" }
          ],
          permission: "tipo_concedente:create",
          title: "Tipos_concedentes - Cadastro"
        }
      },
      {
        name: "tipos_concedentes_edit",
        path: "editar/:id",
        component: () => import("./pages/Edit"),
        meta: {
          breadcrumbs: [
            { label: "Tipos_concedentes", to: "tipos_concedentes_list" }
          ],
          permission: "tipo_concedente:edit",
          title: "Tipos_concedentes - Edição"
        }
      }
    ]
  }
];
